export default "__VITE_ASSET__e37ee006__"